import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=188cd622"
import script from "./channel.vue?vue&type=script&lang=js"
export * from "./channel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default,EducatorPanel: require('/usr/src/app/components/educator/panel.vue').default})
